import type { RovodalBaseState } from '../state-shape/base-state';

import type { RovodalStateRegistry } from './state-registry';

/** Mandatory unique identifier for a Rovodal. The one thing the package owns. */
export type RovodalKey = string;

/**
 * Optional secondary id giving a single {@link RovodalKey} multiple independent
 * entries, each with its own copy of the key's state. Omitted -> the
 * {@link DEFAULT_INSTANCE_ID} singleton.
 */
export type RovodalInstanceId = string;

/** Instance id used when none is supplied. E.g. if we have multiple cards of the same state key */
export const DEFAULT_INSTANCE_ID = '$default';

/** A single Rovodal entry. The package owns `key`, `instanceId` and `isOpen`. */
export type RovodalEntry<TState = unknown, TKey extends RovodalKey = RovodalKey> = {
	readonly key: TKey;
	readonly instanceId: RovodalInstanceId;
	isOpen: boolean;
	/** Consumer-defined payload. */
	state: TState;
};

/** Global store state, nested as `key -> instanceId -> entry`. */
export type RovodalStoreState = {
	byKey: Record<RovodalKey, Record<RovodalInstanceId, RovodalEntry>>;
};

export type RovodalRegisteredKey = keyof RovodalStateRegistry;
export type RovodalStateFor<K extends RovodalRegisteredKey> = RovodalBaseState &
	RovodalStateRegistry[K];

export type RovodalLoadableCanvasProps = {
	rovodalKey: RovodalKey;
	state: unknown;
};
